export const TourFilter = {
    Empty: 0,
    NoTour: 1,
    HasTour: 2,
};